import { render, staticRenderFns } from "./PagesPage.vue?vue&type=template&id=5519b3d6&"
import script from "./PagesPage.vue?vue&type=script&lang=js&"
export * from "./PagesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports